import { defineMessages } from 'react-intl'

const scope = `procurify.expense.presenter.DuplicateExpenseReportPresenter`

export default defineMessages({
  duplicateSuccess: {
    id: `${scope}.duplicateSuccess`,
    defaultMessage: 'Expense report duplicated',
  },
})
